import { useRef, useState } from "react";
import { api, imageUrl } from "@/lib/api";
import { toast } from "sonner";
import { X, Upload, Loader2 } from "lucide-react";

export default function ImageUploader({ value = [], onChange, max = 6 }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const handleFiles = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    const remaining = max - value.length;
    const arr = Array.from(files).slice(0, remaining);
    const uploaded = [];
    for (const f of arr) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/upload", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        uploaded.push(data.path);
      } catch (e) {
        toast.error("Failed to upload " + f.name);
      }
    }
    onChange([...value, ...uploaded]);
    setBusy(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  const remove = (idx) => {
    const next = value.filter((_, i) => i !== idx);
    onChange(next);
  };

  return (
    <div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        className="hidden"
        data-testid="image-uploader-input"
        onChange={(e) => handleFiles(e.target.files)}
      />
      <button
        type="button"
        data-testid="image-uploader-trigger"
        onClick={() => inputRef.current?.click()}
        disabled={busy || value.length >= max}
        className="w-full border border-dashed border-[#C05A3D]/40 rounded-2xl p-8 text-center hover:bg-[#C05A3D]/5 transition disabled:opacity-50"
      >
        {busy ? (
          <span className="inline-flex items-center gap-2 text-[#1E3A2F]"><Loader2 className="w-4 h-4 animate-spin" /> Uploading…</span>
        ) : (
          <span className="inline-flex items-center gap-2 text-[#1E3A2F]"><Upload className="w-4 h-4" /> Click to add photos ({value.length}/{max})</span>
        )}
      </button>
      {value.length > 0 && (
        <div className="mt-4 grid grid-cols-3 sm:grid-cols-4 gap-3">
          {value.map((p, i) => (
            <div key={p + i} className="relative aspect-square rounded-xl overflow-hidden border border-[#E2DED0] group">
              <img src={imageUrl(p)} alt="" className="w-full h-full object-cover" />
              <button
                type="button"
                data-testid={`image-remove-${i}`}
                onClick={() => remove(i)}
                className="absolute top-1 right-1 w-7 h-7 rounded-full bg-white/90 grid place-items-center opacity-0 group-hover:opacity-100 transition"
              >
                <X className="w-4 h-4 text-[#C05A3D]" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
